import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import type { AppInfo } from '../../types/auth';
import { getAppRedirectUrl } from '../../lib/utils';
import './Modal.css';

interface AppSelectorProps {
  apps: AppInfo[];
  token: string;
  onClose: () => void;
}

export function AppSelector({ apps, token, onClose }: AppSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="auth-modal" role="dialog" aria-modal="true">
      <div className="auth-modal__panel">
        <div className="auth-modal__head">
          <h2 className="auth-modal__title">{t('general.appSelectorTitle')}</h2>
          <button
            type="button"
            className="auth-modal__close"
            onClick={onClose}
            aria-label={t('general.closeButton')}
          >
            &times;
          </button>
        </div>
        <p className="auth-modal__text">{t('general.appSelectorDesc')}</p>
        <ul className="auth-app-list">
          {apps.map((app) => (
            <li key={app.appId}>
              <button
                type="button"
                className="auth-app-list__button"
                onClick={() => {
                  window.location.href = getAppRedirectUrl(app, token);
                }}
              >
                <ExternalLink size={18} aria-hidden="true" />
                {app.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
